/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 到店车辆转化+get
Mock.mock(/used_car\/car_exits/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_exits|10': [
      {
        'age_month': 2,
        'age_year': 1,
        'first_sold_at': /|2011-01-25 |2012-01-25|2013-01-25|2014-01-25|2015-01-25|2016-01-25|/,
        'have_left|1-2': true,
        'id|+1': 1,
        'plate_number': '粤B12345',
        'relate_used_car_id': 44,
        'release_by': {
          'name': '郭兵',
          'role': '销售顾问'
        },
        'satisfy_solicit_rule|1-2': false,
        'visited_at': '2017-09-28 13:03:22'
      }
    ],
    'total_num': 80
  }
})
